/* eslint-disable */
import React from "react";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const ClinicDetailsCard = ({ clinic = {} }) => {
  return (
    <div className="clinic-details mt-3 p-3 border border-gray-300 rounded-8 shadow-sm">
      {/* Clinic details */}
      <div className="d-flex gap-3">
        <div
          className="avatar rounded-circle overflow-hidden"
          style={{ width: "60px", height: "60px" }}
        >
          <img
            className="w-100 h-100 object-fit-cover"
            src={
              clinic?.logopath !== ""
                ? url.SERVER_URL + clinic?.logopath
                : assetImages.defaultUser
            }
            alt="clinic"
          />
        </div>
        <div>
          <p className="mb-0">{clinic?.label}</p>
          <p className="font-sm text-gray mb-1">
            Owner: {clinic?.moderatorname}
          </p>
        </div>
      </div>
      <div className="contact-info pt-3 border-top border-gray-100 mt-3">
        <p className="fw-semibold mb-2">
          Information for Clinic {clinic?.label}
        </p>
        <p className="font-sm text-gray mb-1">Phone: {clinic?.phone}</p>
        <p className="font-sm text-gray mb-1">City: {clinic?.city}</p>
        <p className="font-sm text-gray mb-1">State: {clinic?.state}</p>
        <p className="font-sm text-gray mb-1">Country: {clinic?.country}</p>
      </div>
    </div>
  );
};

export default ClinicDetailsCard;
